import ArticleTemplate from '@/components/feature/ArticleTemplate';
import { allArticles } from '@/mocks/articles';

const article = allArticles.find((a) => a.slug === 'vigorbuy-spreadsheet-tips')!;

export default function ArticleTipsPage() {
  return <ArticleTemplate article={article} />;
}